<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="UploadMeterReadings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpAlert
      variant="info"
      show
    >
      <ItpIcon
        fa="info-circle"
      >
      </ItpIcon>
      <ItpText
        wrap
      >
        {{ 'Upload meter readings from a template file and optionally generate consumption data.'|pgettext('UploadMeterReadings') }}
      </ItpText>
    </ItpAlert>
    <hr>
    </hr>
    <DIV
      class="container"
    >
      <ItpForm
        :name="formName"
        :id="formId"
        v-if="loaded"
        @submit="evh_648747096704084_submit($event, {})"
      >
        <ItpFormGroup
          name="file"
          :label="'Events file'|pgettext('UploadMeterReadings')"
          labelFor="file"
          required
        >
          <ItpFormFile
            v-model="file"
            name="file"
            accept=".xlsx"
            required
            :validation="b_3086171180629160_validation"
          >
          </ItpFormFile>
          <DIV
            class="pt-2"
            slot="description"
          >
            <span>
              {{ 'Only XLSX files are allowed.'|pgettext('UploadMeterReadings') }}
            </span>
            <ItpLink
              :text="'Download template'|pgettext('UploadMeterReadings')"
              :href="templateFileURL"
              use-auth
              force-download
              downloadFileName="meter-readings-template.xlsx"
            >
            </ItpLink>
          </DIV>
        </ItpFormGroup>
        <DIV
          name="createConsumptions"
          class="form-check px-0"
        >
          <ItpFormCheckbox
            name="createConsumptions"
            v-model="createConsumptions"
          >
            {{ 'Create consumptions'|pgettext('UploadMeterReadings') }}
          </ItpFormCheckbox>
        </DIV>
      </ItpForm>
      <ItpAlert
        :show="resultText && !actions.submit.isRunning"
        class="mt-3"
      >
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <span>
          {{ resultText }}
        </span>
      </ItpAlert>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="formId"
      :text="'Upload'|pgettext('UploadMeterReadings')"
      type="submit"
      variant="primary"
      icon="fa-file-import"
      :spinning="actions.submit.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UploadMeterReadings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_createConsumptions = new ComponentValueCache(this, "createConsumptions", "UploadMeterReadings.createConsumptions");
  }

  onSumbitCompleted(...args: any[]) {
    const [event] = args;
    const data = event.data.response.data

    console.log(data, this)

    if (data == null) {
      this.resultText = this.messages.noRecordsHaveBeenImported;
      return;
    }

    const
      consumptions = data.consumptions ? data.consumptions.length : 0,
      readings = data.readings ? data.readings.length : 0;

    this.resultText = this.$fn.sprintf(this.messages.recordsHaveBeenImported, {
      consumptions, readings
    });
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  createConsumptions!: any;
  file!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  resultText!: any;
  templateFileURL!: any;

  async $$load_templateFileURL() {
    return this.$fn.urlFor('get_meter_readings_import_template', { format: 'xlsx' })
  }

  messages!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3086171180629160_validation!: any;
  dataMembers = ['createConsumptions', 'file', 'formId', 'formName', 'resultText', 'templateFileURL', 'messages', 'ux', 'b_7315092382398562_modalBindings', 'b_3086171180629160_validation'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        createConsumptions: false,
        file: null,
        formId: null,
        formName: "meterConsumptionImport",
        resultText: null,
        templateFileURL: null,
        messages: {
          noRecordsHaveBeenImported: this.$fn.pgettext("UploadMeterReadings", "No records have been imported."),
          recordsHaveBeenImported: this.$fn.pgettext("UploadMeterReadings", "%(readings)s readings and %(consumptions)s consumptions have been imported."),
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
        b_3086171180629160_validation: ["ext:xlsx"
          ,
          "required"
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("UploadMeterReadings|Title", "Upload Meter Readings"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3544_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3544, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_648747096704084_script_3550_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_648747096704084_script_3550, alias=undefined
    this.onSumbitCompleted($event)
  }

  async act_648747096704084_script_3550_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_648747096704084_script_3550, alias=undefined
    return {
      value: () => this.act_648747096704084_script_3550_getActionArgs_value($event),
    }
  }

  async act_648747096704084_request_3548_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_648747096704084_request_3548, alias=submit
    return {
      operation: "create_meter_readings_from_file",
      data: {
        file: this.file,
        create_consumptions: this.createConsumptions
      },
      contentType: "multipart/form-data",
    }
  }

  async evh_648747096704084_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_3552_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_3552, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3544: actions.CloseModalAction;
    evh_7315092382398562_close_3543: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3546: actions.CloseComponentAction;
    evh_2248226175642056_close_3545: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_648747096704084_script_3550: actions.ScriptAction;
    evh_648747096704084_success_3549: actions.EventHandlerImpl;
    act_648747096704084_request_3548: actions.RequestAction;
    evh_648747096704084_submit_3547: actions.EventHandlerImpl;
    evh_648747096704084_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_3552: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_3551: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3544 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3544_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3543 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3544,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3543],
      }
    );
    const act_2248226175642056_closeComponent_3546 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3545 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3546,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3545],
      }
    );
    const act_648747096704084_script_3550 = new actions.ScriptAction(
      {
        actionArgs: this.act_648747096704084_script_3550_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_3549 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_script_3550,
        event: "success",
        displayName: "script",
      }
    );
    const act_648747096704084_request_3548 = new actions.RequestAction(
      {
        actionArgs: this.act_648747096704084_request_3548_getActionArgs,
        displayName: "submit",
        events: [evh_648747096704084_success_3549],
      }
    );
    const evh_648747096704084_submit_3547 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_request_3548,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_648747096704084_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_648747096704084_submit_3547],
      }
    );
    const act_1419464017721962_closeModal_3552 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_3552_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3551 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_3552,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3551],
      }
    );
    return {
      act_7315092382398562_closeModal_3544,
      evh_7315092382398562_close_3543,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3546,
      evh_2248226175642056_close_3545,
      evh_2248226175642056_close,
      act_648747096704084_script_3550,
      evh_648747096704084_success_3549,
      act_648747096704084_request_3548,
      evh_648747096704084_submit_3547,
      evh_648747096704084_submit,
      act_1419464017721962_closeModal_3552,
      evh_1419464017721962_clickPreventStop_3551,
      evh_1419464017721962_clickPreventStop,
      submit: act_648747096704084_request_3548,
    }
  }
}

Vue.component("UploadMeterReadings", UploadMeterReadings);

</script>